import Vue from 'vue'

export default {
  data() {
    return {
      sidePanelOpen: true,
      selectedTabKey: 'all',
    }
  },
  computed: {
    tabsItems() {
      const locale = Vue.i18n.locale
      return [
        {
          text: this.$t('pointOfSales.sidepanel.header.tabs.all'),
          key: 'all'
        },
        {
          text: this.$t('pointOfSales.sidepanel.header.tabs.rechargeOnly'),
          key: 'rechargeOnly'
        },
        {
          text: this.$t('pointOfSales.sidepanel.header.tabs.acquisitionAndRecharge'),
          key: 'adquisitionAndRecharge'
        },
        {
          text: this.$t('pointOfSales.sidepanel.header.tabs.additionalCapabilities'),
          key: 'additionalCapabilities'
        }
      ]
    }
  },
  methods: {
    /*
     * Muestra el popup en el mapa al seleccionar un punto de venta de la lista
     */
    showPointOfSales(pointOfSales) {
      const vm = this
      vm.showPopup(pointOfSales.marker)
      vm.centerMap(pointOfSales.position)

      if (vm.$isPortable) {
        vm.sidePanelOpen = false
      }
    },

    /*
     * Modifica el valor de sidePanelOpen que envía el evento emitido por el componente sidepanel
     */
    changeOpen(newOpen) {
      this.sidePanelOpen = newOpen
    },

    /*
     * Cambia la pestaña seleccionada
     */
    tabChange(tabKey) {
      this.selectedTabKey = tabKey
      this.resetSidepanelScroll()
    }
  }
}
